import { useScript } from "../libs/common/cached-scripts";
import { useCallback, useEffect } from "react";
import { ENV } from "../constants/env";

const useDynatrace = () => {
    const [, , doLoad] = useScript();
    const dynatrace = useCallback(() => {
        if (Number(process.env.REACT_APP_ENABLE_DYNATRACE) === 1) {
            doLoad(
                `${process.env.PUBLIC_URL}/js/dynatrace${
                    Number(process.env.REACT_APP_IS_DEVELOPMENT) ? "" : ".prod"
                }.js`
            );
        }
    }, [doLoad]);
    useEffect(() => {
        setTimeout(() => {
            dynatrace();
        }, ENV.LANDING.VENDORS_DELAY);
    }, [dynatrace]);
};

export default useDynatrace;
